<template>
  <div class="col-lg-12">
    <!-- Basic elements -->
    <h3 class="mb-3">
      <span>About</span>
    </h3>
    <div
      class="text-dark"
    >Lorem ipsum, dolor sit amet consectetur adipisicing elit. Amet reiciendis minus facilis optio a ea, aperiam quo dicta, et placeat consequuntur quasi laudantium explicabo! Aut eaque earum debitis ipsum mollitia.</div>
  </div>
</template>
<script>
export default {};
</script>
<style>
</style>
